// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jIQA","left":"styles_left__3nnid","right":"styles_right__2eYZu","alert":"styles_alert__2lBd4"};